import { Theme } from '@mui/material/styles';
import { alpha, darken } from '@mui/material';

export default function Button(theme: Theme) {
  const disabledStyle = {
    '&.Mui-disabled': {
      backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[800],
      color: theme.palette.text.disabled,
    },
  };

  return {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          fontWeight: 600,
          borderRadius: 10,
          textTransform: 'capitalize',
        },
        containedPrimary: {
          backgroundColor: theme.palette.accent.main,
          color: theme.palette.accent.contrastText,
          '&:hover': {
            backgroundColor: darken(theme.palette.accent.main, 0.12),
          },
        },
        contained: {
          ...disabledStyle,
        },
        outlinedSecondary: {
          color: theme.palette.text.secondary,
          borderColor: theme.palette.divider,
          '&:hover': {
            color: theme.palette.text.primary,
            borderColor: theme.palette.primary.main,
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
          },
        },
        sizeSmall: {
          minHeight: 32,
        },
        sizeMedium: {
          minHeight: 36,
        },
        sizeLarge: {
          minHeight: 48,
        },
      },
    },
  };
}
